import React from 'react'
import { IonItem, IonAlert } from '@ionic/react'
import { ArrowRightIcon, DeleteIcon } from '../../conf/images'
import { useHistory } from 'react-router'
import { SetNewsBotPage } from '../../conf/routePath'
import { NewsBotSetting } from '.'
import { removeNewsBotSet } from '../../service/api/bot'

interface Props {
    mode: boolean
    item: NewsBotSetting
    removeItem: (id: string) => void
}

const NewsBotDetailItem: React.FC<Props> = (props) => {
    const history = useHistory()
    const [showAlert, setShowAlert] = React.useState(false)
    return (
        <IonItem
            className='newsBotSetItem'
            onClick={() => {
                if (props.mode) {
                    history.push(SetNewsBotPage, { item: props.item })
                } else {
                    setShowAlert(true)
                }
            }}
        >
            <div className='newsBotSetItemWarp'>
                <p>{props.item.name}</p>
                {props.item.friend_reply_list.map((item, index) => (
                    <img
                        className='profilePicture'
                        key={index}
                        src={item.head_url}
                        alt='profilePicture'
                    />
                ))}
            </div>

            <div className='newsBotSetItemIcon'>
                <img
                    src={props.mode ? ArrowRightIcon : DeleteIcon}
                    alt='icon'
                />
            </div>

            <IonAlert
                isOpen={showAlert}
                onDidDismiss={() => setShowAlert(false)}
                header={'提示'}
                message={'您确定要删除这一项吗?'}
                buttons={[
                    {
                        text: '取消',
                        role: 'cancel',
                        handler: (blah) => {
                            setShowAlert(false)
                        },
                    },
                    {
                        text: '确认',
                        handler: () => {
                            setShowAlert(false)
                            removeNewsBotSet(props.item.id)
                            props.removeItem(props.item.id)
                        },
                    },
                ]}
            />
        </IonItem>
    )
}

export default NewsBotDetailItem
